<!--
/*******************************************************************************
*@ 컴포넌트명   : Product1101001000022ogvtn.vue
*@ 컴포넌트설명 :[베트남] 예금 상품 > 예금 상품 상세(특별자본금계좌)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->

<template>
  <section class="deposit detail">
     <!--한국어-->
    <template v-if="lang == $config.LANG_KOR">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>특별자본금계좌</h2>
          </div>
          <div class="description">
            <p>
              회사설립 및 대베트남 직,간접투자를 위한 자본금을 예치하는 예금으로 입금 및 출금이 거래성격에 따라 제한되는 예금
            </p>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>상품유형</dt>
            <dd>보통예금</dd>
            <dt>상품개요</dt>
            <dd>회사설립 및 대베트남 직,간접투자를 위한 자본금을 예치하는 예금으로 입금 및 출금이 거래성격에 따라 제한되는 예금</dd>
            <dt>가입대상</dt>
            <dd>베트남 법령에 따라 설립되고 운영되는 베트남 기관, 개인</dd>
            <dt>계약기간</dt>
            <dd>제한없음</dd>
            <dt>가입통화</dt>
            <dd>VND, USD</dd>
            <dt>가입금액</dt>
            <dd>제한없음</dd>
            <dt>금리 및 이율</dt>
            <dd>약정이율 연 0.00%</dd>
            <dt>수수료</dt>
            <dd>해당무</dd>
            <dt>가입방법</dt>
            <dd>영업점가입</dd>
            <dt>가입시 필요서류</dt>
            <dd>영업점 문의</dd>
            <dt>유의사항 및 기타</dt>
            <dd>회사 자본금을 관리하는 계좌로 입금 및 출금이 거래 성격에 따라 제한됨</dd>
          </dl>
        </article>
      </div>
    </template>

     <!--영어-->
    <template v-else-if="lang == $config.LANG_ENG">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>Special capital account</h2>
          </div>
          <div class="description">
            <p>
              This is a special account to deposit a capital for the establishment of the company or for direct and indirect investor, however, deposits and withdrawals of money might be restricted depending on the caracteristics of transaction.  
            </p>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>Types</dt>
            <dd>Current Account</dd>
            <dt>About the products</dt>
            <dd>This is a special account to deposit a capital for the establishment of the company or for direct and indirect investor, however, deposits and withdrawals of money might be restricted depending on the caracteristics of transaction.</dd>
            <dt>Eligibilty</dt>
            <dd>The Corporation that is established and operated in accordance with the laws and regulations of Vietnamese or individual</dd>
            <dt>Contract Terms</dt>
            <dd>No restrictions</dd>
            <dt>Available currency</dt>
            <dd>VND, USD</dd>
            <dt>Deposit amount</dt>
            <dd>No restrictions</dd>
            <dt>Loan Rate</dt>
            <dd>Agreed interest rate : 0.00% annually</dd>
            <dt>Fees</dt>
            <dd>N/A</dd>
            <dt>How to apply</dt>
            <dd>Apply at the branch</dd>
            <dt>Required documents for application</dt>
            <dd>Contact to our staff</dd>
            <dt>Notices and others</dt>
            <dd>This is an account to manage the compnay funds and deposits, however, withdrawals of money might be restricted depending on the caracteristics of transaction</dd>
          </dl>
        </article>
      </div>
    </template>

     <!--베트남-->
    <template v-else>
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>Tiền gửi thanh toán doanh nghiệp</h2>
          </div>
          <div class="description">
            <p>
              Là hình thức tiền gửi mà quý khách có thể tự do nạp và rút tiền mà không cần phải ấn định thời gian
            </p>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>Hình thức sản phẩm</dt>
            <dd>Tiền gửi thông thường</dd>
            <dt>Giới thiệu sản phẩm</dt>
            <dd>Là hình thức tiền gửi mà quý khách có thể tự do nạp và rút tiền mà không cần phải ấn định thời gian</dd>
            <dt>Đối tượng gia nhập</dt>
            <dd>Pháp nhân được thành lập và hoạt động theo pháp luật Việt Nam hoặc pháp luật nước ngoài</dd>
            <dt>Thời gian hợp đồng</dt>
            <dd>Không giới hạn</dd>
            <dt>Loại tiền tệ gia nhập</dt>
            <dd>VND, USD</dd>
            <dt>Số tiền gia nhập</dt>
            <dd>Không giới hạn</dd>
            <dt>Lãi suất</dt>
            <dd>Lãi suất cam kế t: USD 0.00% một năm, VND 0.10% một năm</dd>
            <dt>Biểu phí</dt>
            <dd>Không có nội dung tương ứng</dd>
            <dt>Cách thức gia nhập</dt>
            <dd>Tham gia chi nhánh</dd>
            <dt>Giấy tờ cần thiết khi gia nhập</dt>
            <dd>- Giấy phép thành lập hoặc hồ sơ pháp lý chứng minh việc thành lập hợp pháp.<br>
                - Tài liệu chứng minh người đại diện có thể ủy quyền pháp lý đại diện cho công ty.<br>
                - CMND hoặc hộ chiếu hoặc mẫu chữ ký công chứng của người đại diện.<br>
                - Giấy ủy quyền của người đại diện ( trường hợp không phải là người đại diện gửi tiền )<br>
                - Đăng ký chữ ký của người được ủy quyền, phạm vi quản lý tài khoản ( trường hợp không phải là người đại diện gửi tiền )<br>
                - CMND hoặc hộ chiếu hoặc mẫu chữ ký công chứng của người được ủy quyền ( trường hợp không phải là người đại diện gửi tiền )</dd>
            <dt>Lưu ý</dt>
            <dd>Số dư tối thiểu để duy trì tài khoản 10.00 USD</dd>
          </dl>
        </article>
      </div>
    </template>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed:{
    ...mapFields(["lang"]),
  }
};
</script>
